import type { CSSProperties } from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

const override: CSSProperties = {
  display: "block",
  left: "50%",
  margin: "auto",
  position: "fixed",
  top: "50%",
  zIndex: "9999",
};

interface PropType {
  color: string;
  loading?: boolean;
}
function FullScreenSpinner(props: PropType) {
  const { loading = true, color } = props;

  return (
    <div className="sweet-loading">
      <ScaleLoader
        color={color}
        loading={loading}
        cssOverride={override}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default FullScreenSpinner;
